/**
  API Key API wrapper

	JSON endpoint:  /aws_api/manage.json
	GET  /aws_api/manage.json?loid={loid} - Get current API key
	POST  /aws_api/manage.json?loid={loid} - Create new API key
	DELETE  /aws_api/manage.json?id={id} - Delete API key
**/

import { api } from "../common/utils"
import { APIKEY_ENDPOINT, API_KEYS_ADMIN_ENDPOINT } from "../common/constants"
import { APIKeyRespose, APIKeyCreateResponse } from "../types"

export interface AdminApiKey {
  id: string
  key_name: string | null
  key_suffix: string
  owner: string
  owner_name: string
  loid: string
  created: string
  status: string
  org_id: string
  org_name: string
}

export interface AdminApiKeysResponse {
  status: string
  api_keys: AdminApiKey[]
  pagination: {
    total: number
    limit: number
    offset: number
    page: number
    total_pages: number
  }
}

const apiKey = {
  getAllAdmin: async (): Promise<AdminApiKeysResponse> => {
    const { data } = await api.get(API_KEYS_ADMIN_ENDPOINT)
    return data
  },
  get: async (loid: string): Promise<APIKeyRespose> => {
    if (!loid) {
      throw new Error("loid missing")
    }
    const { data } = await api.get(APIKEY_ENDPOINT + "?loid=" + loid)
    return data.length ? data[0] : undefined
  },
  getAll: async (owner: string): Promise<APIKeyRespose[]> => {
    if (!owner) {
      throw new Error("owner missing")
    }
    const { data } = await api.get(APIKEY_ENDPOINT + "?owner=" + owner)
    return Array.isArray(data) ? data : []
  },
  generate: async (loid: string): Promise<APIKeyCreateResponse> => {
    if (!loid) {
      throw new Error("loid missing")
    }
    const { data } = await api.post(APIKEY_ENDPOINT, { loid, owner: loid })
    return data
  },
  delete: async (id: string): Promise<any> => {
    if (!id) {
      throw new Error("id missing")
    }
    const { data } = await api.delete(APIKEY_ENDPOINT + "?id=" + id)
    return data
  }
}

export default apiKey
